import ApiServices from "../../../components/application/effective_contract/services/api.services";
import _ from "lodash";
import Vue from 'vue'
import CheckContractServices from "../../../components/application/effective_contract/services/CheckContract.services";
import {getField, updateField} from 'vuex-map-fields';
import EffContractServices from "../../../components/application/effective_contract/services/EffContract";

const EffectiveContractStore = {
    namespaced: true,
    state: () => ({
        payloadOrder: {
            academic_title: "",
            bid: null,
            dean: false,
            head_department: false,
            is_sent_review: false,
        },

        payloadPersonContract: {
            fact: null,
            author: null,
            eff_contract_id: null,
            is_sent_review: false,
            contract_confirm: false,
            file: null,
            link_source: null,
        },

        listEffContracts: [],

        personEffContracts: [],

        typeDialogContract: "",

        dialogContract: false,

        orderPresent: true,

        isEditDialog: false,

        dataEmployee: {},

        teachersList: [],
    }),

    getters: {
        getPayloadOrderField(state) {
            return getField(state.payloadOrder);
        },

        getPayloadPersonContract(state) {
            return getField(state.payloadPersonContract);
        },

        listBasicBidContract(state) {
            return _.filter(state.listEffContracts, {"kind": "basic", "position": "Оклад"})
        },

        listStimulatingBidContract(state) {
            return _.filter(state.listEffContracts, {"kind": "stimulating", "position": "Оклад"})
        },

        listBasicDeanContract(state) {
            return _.filter(state.listEffContracts, {"kind": "basic", "position": "Декан"})
        },

        listStimulatingDeanContract(state) {
            return _.filter(state.listEffContracts, {"kind": "stimulating", "position": "Декан"})
        },

        listBasicHeadDepartmentContract(state) {
            return _.filter(state.listEffContracts, {"kind": "basic", "position": "Заведующий кафедрой"})
        },

        listStimulatingHeadDepartmentContract(state) {
            return _.filter(state.listEffContracts, {"kind": "stimulating", "position": "Заведующий кафедрой"})
        },

        listPersonBasicBidContract(state) {
            return _.filter(state.personEffContracts, (i) => {
                return i.eff_contract.kind === "basic" && i.eff_contract.position === "Оклад"
            })
        },

        listPersonStimulatingBidContract(state) {
            return _.filter(state.personEffContracts, (i) => {
                return i.eff_contract.kind === "stimulating" && i.eff_contract.position === "Оклад"
            })
        },

        listPersonBasicDeanContract(state) {
            return _.filter(state.personEffContracts, (i) => {
                return i.eff_contract.kind === "basic" && i.eff_contract.position === "Декан"
            })
        },

        listPersonStimulatingDeanContract(state) {
            return _.filter(state.personEffContracts, (i) => {
                return i.eff_contract.kind === "stimulating" && i.eff_contract.position === "Декан"
            })
        },

        listPersonBasicHeadDepartmentContract(state) {
            return _.filter(state.personEffContracts, (i) => {
                return i.eff_contract.kind === "basic" && i.eff_contract.position === "Заведующий кафедрой"
            })
        },

        listPersonStimulatingHeadDepartmentContract(state) {
            return _.filter(state.personEffContracts, (i) => {
                return i.eff_contract.kind === "stimulating" && i.eff_contract.position === "Заведующий кафедрой"
            })
        },

        isDean(state) {
            if (state.payloadOrder === null) return false
            return state.payloadOrder?.dean || false
        },

        isHeadDepartment(state) {
            if (state.payloadOrder === null) return false
            return state.payloadOrder?.head_department || false
        },

        isAdmin(state) {
            if (_.isNil(state.dataEmployee)) return false
            return state.dataEmployee.is_umu
        },

        isUMUManager(state) {
            if (_.isNil(state.dataEmployee)) return false
            return state.dataEmployee.is_admin
        },

        checkBasicBid(state, getters) {
            if (state.payloadOrder === null && getters.listPersonBasicBidContract.length === 0) return []
            return CheckContractServices.checkedPath(getters.listPersonBasicBidContract, getters.listBasicBidContract);
        },

        checkBasicHeadDepartment(state, getters) {
            if (state.payloadOrder === null && getters.listPersonBasicHeadDepartmentContract.length === 0) return []
            return CheckContractServices.checkedPath(getters.listPersonBasicHeadDepartmentContract, getters.listBasicHeadDepartmentContract);
        },

        checkBasicDean(state, getters) {
            if (state.payloadOrder === null && getters.listPersonBasicDeanContract.length === 0) return []
            return CheckContractServices.checkedPath(getters.listPersonBasicDeanContract, getters.listBasicDeanContract);
        },

    },

    mutations: {
        updatePayloadOrderField(state, field) {
            updateField(state.payloadOrder, field);
        },

        updatePayloadPersonContract(state, field) {
            updateField(state.payloadPersonContract, field);
        },

        setFactWithOutAuthor(state, author) {
            state.payloadPersonContract.fact = (1 / Number(author)).toFixed(2)
        },

        setPayloadOrder: (state, response) => {
            state.payloadOrder = response
        },

        setPayloadPersonContract: (state, response) => {
            state.payloadPersonContract = response
        },

        resetPayloadPersonContract: (state) => {
            const payloadPersonContract = {
                fact: null,
                author: null,
                eff_contract_id: null,
                is_sent_review: false,
                contract_confirm: false,
                file: null,
            };

            state.payloadPersonContract = _.cloneDeep(payloadPersonContract);
        },

        setDialog: (state, flag) => state.dialogContract = flag,

        setPersonEffContracts: (state, response) => {
            state.personEffContracts = response
        },

        setListEffContracts: (state, response) => {
            state.listEffContracts = response
        },

        pushNewPersonContractList: (state, response) => {
            state.personEffContracts.push(response)
        },

        setTypeDialogContract: (state, type) => {
            state.typeDialogContract = type
        },

        setIsEditDialog: (state, flag) => {
            state.isEditDialog = flag
        },

        setEditPayloadPersonContract(state, item) {
            const editPersonContract = _.cloneDeep(item);
            state.payloadPersonContract = _.pick(editPersonContract, ['fact', 'author', 'id', 'file']);
            state.payloadPersonContract.eff_contract_id = editPersonContract.eff_contract.id;
        },

        setDataEmployee: (state, response) => {
            state.dataEmployee = response
        },

        setTeachersList: (state, response) => {
            state.teachersList = response
        },

        setContractsWithTeachersList(state, {index, contracts}) {
            Vue.set(state.teachersList[index], 'person_eff_contracts', contracts);
        },

        resetReviewOrder(state, {index, order}) {
            Vue.set(state.teachersList[index], 'teacher_eff_order', order);
        },


        updateValueWithKeyList(state, {list, index, key, value}) {
            Vue.set(list[index], key, value);
        },

        updateValueWithKeyListPersonEffCon(state, {list, index, key, value}) {
            Vue.set(list[index].eff_contract, key, value);
        },


    },

    actions: {

        async multiplicationByPlanRate({state}) {
            if (!state.listEffContracts.length > 0) return ;
            const replacedContracts = EffContractServices.findContractsDependentOnBid(state.listEffContracts);

            _.forEach(replacedContracts, (replaceContract)=> {
                EffContractServices.calculatePlanDescriptionWithBid(
                    state.listEffContracts,
                    replaceContract,
                    state.payloadOrder.bid,
                    'plan_description'
                );
                EffContractServices.calculatePlanWithBid(
                    state.listEffContracts,
                    replaceContract,
                    state.payloadOrder.bid,
                    'plan'
                );
            });
        },

        async getEffConOrder({state, commit}) {
            try {
                const response = await ApiServices.getEffConOrder();
                const res =  response.data
                res.bid = res.bid.toFixed(2)
                commit('setPayloadOrder', res);
            } catch (e) {
                state.orderPresent = false;
                // console.warn(e);
            }
        },

        async getPersonEffContracts({state, commit}) {
            try {
                const response = await ApiServices.getPersonEffContracts();
                commit('setPersonEffContracts', response.data.person_eff_contracts);
            } catch (e) {
                console.warn(e);
            }
        },

        async sendEffContract({state, commit, dispatch}, methodSend) {
            try {
                let response;
                switch (methodSend) {
                    case 'POST':
                        response = await ApiServices.createEffConOrder(state.payloadOrder);
                        state.orderPresent = true;
                        dispatch("getPersonEffContracts");
                        dispatch("getEffContracts");
                        break;
                    case 'PUT':
                        response = await ApiServices.updateEffConOrder(state.payloadOrder, state.payloadOrder.id);
                        break;
                    default:
                        console.warn("Не указан метод отправки")
                        response = state.payloadOrder;
                        break;
                }
                commit('setPayloadOrder', response.data)
            } catch (e) {
                console.warn(e);
            }
        },

        async sendPersonEffContract({state, commit}, id = null) {
            try {
                if (state.isEditDialog) {
                    const response = await ApiServices.updatePersonEffContract(state.payloadPersonContract, state.payloadPersonContract?.id);
                    commit("setPersonEffContracts", response.data.person_eff_contracts);
                } else {
                    const response = await ApiServices.createPersonEffContract(state.payloadPersonContract);
                    commit("setPersonEffContracts", response.data.person_eff_contracts);
                }
            } catch (e) {
                console.log(e);
            }
        },

        async deletePersonEffContract({state, commit}, id) {
            try {
                const response = await ApiServices.deletePersonEffContract(id);
                commit("setPersonEffContracts", response.data.person_eff_contracts);
            } catch (e) {
                console.log(e);
            }
        },

        async getEffContracts({commit}) {
            try {
                const response = await ApiServices.getListEffContracts();
                commit("setListEffContracts", response.data);
            } catch (e) {
                console.warn(e);
            }
        },

        async getDataEmployee({commit}) {
            try {
                const response = await ApiServices.getDataEmployee();
                commit("setDataEmployee", response.data);
            } catch (e) {
                console.warn(e);
            }
        },

        async getTeacherList({commit}) {
            try {
                const response = await ApiServices.getTeacherList();
                commit("setTeachersList", response.data.teachers_list);
            } catch (e) {
                console.warn(e);
            }
        },

        async sentReviewContracts({commit}) {
            try {
                const response = await ApiServices.sentPersonContractsToReview();
                commit("setPayloadOrder", response.data);
            } catch (e) {
                console.warn(e);
            }
        },

        async resetPersonContractsToReview({commit}, {index, id}) {
            try {
                const response = await ApiServices.resetPersonContractsToReview(id);
                commit("resetReviewOrder", {index: index, order: response.data});
            } catch (e) {
                console.warn(e);
            }
        },

        async autoCalculateFactsAction({dispatch}) {
            await ApiServices.autoCalculateFacts();
            dispatch("getPersonEffContracts")
        },

        async setDialogAction(context, flag) {
            if (!flag) {
                context.commit("setTypeDialogContract", "");
                context.commit('resetPayloadPersonContract');
                context.commit("setIsEditDialog", false);
            }
            context.commit("setDialog", flag);
        },
    },
}

export default EffectiveContractStore